import CategoryType from 'owa-service/lib/contract/CategoryType';
import { CategoryMetadata } from '../schema/CategoryMetadata';
import { getColorSchemeForCategory } from '../utils/getColorSchemeForCategory';

export const getCategoryMetadataFromCategory = (category: CategoryType): CategoryMetadata => ({
    categoryType: category,
    colorScheme: getColorSchemeForCategory(category),
});
